import { Record } from 'immutable';
import { buildAudit } from '../../audit/operators/buildAudit';
class OriginatingAuditContext extends Record({
  auditParams: null
}, 'OriginatingAuditContext') {
  constructor(props = {}) {
    super({
      auditParams: props.auditParams ? buildAudit(props.auditParams) : null
    });
  }
}
export default OriginatingAuditContext;